import React, { useEffect } from 'react'

import { fetchCategories } from './dashboard-actions'
import { setActivityFromLocalStorage } from './dashboard-slice'

import { useAppDispatch } from 'common/hooks'
import { loadState } from 'common/utils'
import { Layout } from 'layout'

export const Dashboard = () => {
  const dispatch = useAppDispatch()

  // fetching data and setting data from localStorage
  useEffect(() => {
    dispatch(fetchCategories())
      .unwrap()
      .then(() => {
        const activity = loadState('activity')

        if (activity) {
          dispatch(setActivityFromLocalStorage(activity))
        }
      })
      .catch(e => {
        console.log(e)
      })
  }, [])

  return <Layout />
}
